import $ from "jquery";

// Form modal click
$("body").on("click tap", "[data-open-overlay-page]", function () {
    var pageID = $(this).attr("data-open-overlay-page");

    console.debug("open overlay page", pageID);

    $("#overlay-page-content").html(
        `<iframe src="${HOME_URL}/overlay-page/${pageID}" width="100%" height="274" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`
    );

    $("#overlay-page").foundation("open");
});

$(document).on("open.zf.reveal", "#overlay-page", function () {
    // console.log("open form overlay");
});

$(document).on("closed.zf.reveal", "#overlay-page", function () {
    // console.log("close form overlay");
    $("#overlay-page-content").html("");
});
